import { isNil } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MicButton from '../MicButton';
import MicPermissionsTestSuccessCard from './MicPermissionsTestSuccessCard';
import PermissionsScreenshot from '../../../../images/PermissionsScreenshot';
import { getAudioStream, isMicPermissionDenied } from '../TROInstructionsUtils';

import { MIC_PERMISSION_STATUSES, MIC_FAILURE_TYPES } from '../TROInstructionsConstants';
import { MIC_PERMISSION_ERROR_NAME } from '../../../../constants/error';

const { ACCESS_DENIED, ACCESS_FAILED } = MIC_FAILURE_TYPES;

class MicPermissionsCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isSuccessCard: false,
            isButtonActive: true,
        };
    }

    componentDidMount() {
        const { narrateScreen, micInitialStatus, isExternalURLSourcePresent, arLanguage } = this.props;

        if (isMicPermissionDenied(micInitialStatus)) {
            this.handleOnFailure(ACCESS_DENIED);
        } else {
            narrateScreen(isExternalURLSourcePresent, arLanguage);
        }
    }

    componentWillUnmount() {
        this.props.cleanup();
    }

    handleOnFailure = errorName => {
        this.props.onFailure(errorName);
        this.props.onPermissionsError({ name: errorName });
    };

    onMicButtonClick = async () => {
        this.setState({ isButtonActive: false });
        try {
            const stream = await getAudioStream();

            if (isNil(stream)) {
                this.handleOnFailure(ACCESS_FAILED);
            } else {
                this.setState({ isSuccessCard: true });
                this.props.setRecordingStream(stream);
                this.props.onSuccess();
            }
        } catch (error) {
            const errorName = error.toString().includes(MIC_PERMISSION_ERROR_NAME) ? ACCESS_DENIED : ACCESS_FAILED;
            this.handleOnFailure(errorName);
        }
    };

    renderSuccessCard = () => <MicPermissionsTestSuccessCard text="Microphone is on" onDone={this.props.onDone} />;

    renderPromptCard = () => (
        <div className="mic-permissions-card">
            <div className="instruction-content">
                <PermissionsScreenshot />
                <MicButton
                    ariaLabel="Turn microphone on"
                    className={!this.props.isScreenBlocked && this.state.isButtonActive ? 'isPulsating' : ''}
                    text="Turn microphone on"
                    onClick={this.onMicButtonClick}
                    disabled={this.props.isScreenBlocked}
                />
            </div>
        </div>
    );

    render() {
        return this.state.isSuccessCard ? this.renderSuccessCard() : this.renderPromptCard();
    }
}

MicPermissionsCard.propTypes = {
    onDone: PropTypes.func,
    cleanup: PropTypes.func,
    onSuccess: PropTypes.func,
    onFailure: PropTypes.func,
    narrateScreen: PropTypes.func,
    setRecordingStream: PropTypes.func,
    onPermissionsError: PropTypes.func,
    micInitialStatus: PropTypes.oneOf([...Object.values(MIC_PERMISSION_STATUSES), null]),
    isScreenBlocked: PropTypes.bool,
    isExternalURLSourcePresent: PropTypes.bool.isRequired,
    arLanguage: PropTypes.string.isRequired,
};

MicPermissionsCard.defaultProps = {
    onDone: () => { },
    cleanup: () => { },
    onSuccess: () => { },
    onFailure: () => { },
    narrateScreen: () => { },
    setRecordingStream: () => { },
    onPermissionsError: () => { },
    micInitialStatus: null,
    isScreenBlocked: false,
};

export default MicPermissionsCard;
